var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('the-header'),_c('div',{staticClass:"content_body flex"},[_c('div',{staticClass:"nav_sidebar"},[_c('the-sidebar')],1),_c('section',{staticClass:"main_content"},[_c('router-view',{staticClass:"viewer container m-auto"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }